module.exports = __webpack_public_path__ + "static/media/translate.d48e1353.png";